export function areArraysDifferent(arr1, arr2) {
  // Check if arrays have different lengths
  if (arr1.length !== arr2.length) {
    return true;
  }
  // Compare elements at each position
  for (let i = 0; i < arr1.length; i++) {
    if (arr1[i]?.id !== arr2[i]?.id) {
      return true;
    }
  }
  // Arrays are identical
  return false;
}

export function areObjectsEqual(obj1, obj2) {
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  // Check if the number of properties is the same
  if (keys1.length !== keys2.length) {
    return false;
  }

  // Check if the values of corresponding properties are equal
  for (const key of keys1) {
    if (obj1[key] !== obj2[key]) {
      return false;
    }
  }

  return true;
}

export const presets = [
  { label: "Today", start: new Date(), end: new Date() },
  {
    label: "Last 7 days",
    start: new Date(new Date(new Date().setDate(new Date().getDate() - 6)).toDateString()),
    end: new Date(new Date().toDateString()),
  },
  {
    label: "Current Month",
    start: new Date(new Date(new Date().setDate(1)).toDateString()),
    end: new Date(new Date(new Date(new Date().setMonth(new Date().getMonth() + 1)).setDate(0)).toDateString()),
  },
  { label: "Last 30 Days", start: new Date(new Date().setDate(new Date().getDate() - 29)), end: new Date() },
  { label: "Last 90 Days", start: new Date(new Date().setDate(new Date().getDate() - 89)), end: new Date() },
];

export const isEmpty = (obj) => {
  for (const prop in obj) {
    if (Object.hasOwn(obj, prop)) {
      return false;
    }
  }
  return true;
};

export const getData = (data, widgetData, combinedWidgetData) => {

  if (data) return data;

  if (!widgetData?.widgetContent?.length || !combinedWidgetData?.length) return [];
  const ids = widgetData?.widgetContent.map((c) => c.widgetContentId);
  widgetData.widgetContent.map((w) => {
    const isExistData = combinedWidgetData.find((c) => w.widgetContentId === c.id);
    if (isExistData) isExistData.personalizedViewId = w.personalizedViewId;
  })
  const orderMapping = widgetData.widgetContent.reduce((acc, c) => {
    if (c.widgetContentId != null) {
      acc[c.widgetContentId] = c.widgetContentOrder;
    }
    return acc;
  }, {});
  const rightData = combinedWidgetData.filter((e) => ids.includes(e.id)).sort((a, b) => (orderMapping[a.id] || 0) - (orderMapping[b.id] || 0));

  return rightData;
};

export const getKeyPlyersData = (data, widgetData, combinedWidgetData) => {
  // Check if `data` is truthy, return `data` if true
  if (data?.length) return data;

  // Check if `widgetData` or `combinedWidgetData` are empty or undefined, return empty array if true
  if (!widgetData?.widgetContent?.length || !combinedWidgetData?.length) return [];

  const orderMapping = widgetData.widgetContent.reduce((acc, c) => {
    if (c.widgetContentId != null) {
      acc[c.widgetContentId] = c.widgetContentOrder;
    }
    return acc;
  }, {});

  const rightData = combinedWidgetData
    .map((e) => {
      const matchingWidgetContent = widgetData?.widgetContent.find((w) => w.widgetContentId === e.id);
      return { ...e, widgetContentKeyPlayerCategory: matchingWidgetContent?.widgetContentKeyPlayerCategory };
    })
    .filter((e) => e.widgetContentKeyPlayerCategory)
    .sort((a, b) => (orderMapping[a.id] || 0) - (orderMapping[b.id] || 0));

  // Return the processed `rightData`
  const keyPlayersNewlyAddedData = rightData?.filter((c) => c.widgetContentKeyPlayerCategory === "Newly Added") || [];
  const keyPlayersRecentlyUpdatedData = rightData?.filter((c) => c.widgetContentKeyPlayerCategory === "Recently Updated") || [];
  return [...keyPlayersNewlyAddedData, ...keyPlayersRecentlyUpdatedData];
};

export const getFirstPublishedDate = (ele) => {
  if (!ele?.productVariant?.length) return "";
  const productVariant = ele?.productVariant?.filter((x) => x.productName === "Insider" && x.isLive === "YES");
  return productVariant.length ? productVariant[0].firstPublishedDate : "";
};

export const getUniqueTags = (tags) => {
  if (!tags?.length) return [];
  // Using reduce to accumulate unique tags based on trendId
  const uniqueTagsMap = tags.reduce((acc, cur) => {
    acc[cur.trendId] = cur; // Store each tag object with trendId as key
    return acc;
  }, {});
  // Convert the uniqueTagsMap object back to an array of unique tags
  const uniqueTags = Object.values(uniqueTagsMap);
  return uniqueTags;
};

export const getFilteredAndSortedValues = (dataSource, allowedValues) =>
  dataSource.filter((v) => allowedValues.includes(v.value)).sort((a, b) => a.label.localeCompare(b.label));

export const removeHtmlTags = (htmlString) => htmlString?.replace(/&nbsp;/g, " ")?.replace(/<(?!\/?highlight\b)[^>]*>/g, "");

export const getIndustryTags = (tags) => {
  if (!tags) return;
  const sortOrderExists = tags?.some((obj) => obj.hasOwnProperty("trendSortOrder"));
  if (sortOrderExists) {
    return tags
      .filter((obj) => obj.hasOwnProperty("trendSortOrder"))
      .sort((a, b) => a?.trendSortOrder - b?.trendSortOrder)
      .map((ele) =>
        Object.assign({}, ele, {
          trendId: ele.trendParentId ? ele.trendParentId : ele.trendId,
        })
      );
  } else {
    let filteredTags = tags.filter(
      // (tag) => tag.trendParentId !== 0 && tag.trendRoot === tag.trendParentId
      (tag) => tag.trendParentId !== 0 && tag.trendIsSgf !== 1 && tag.trendSgfParentId === undefined
    );

    if (filteredTags.length === 0) {
      filteredTags = tags.filter((tag) => tag.trendParentId !== 0 && tag.trendIsSgf !== 1);
    }
    return filteredTags?.map((ele) =>
      Object.assign({}, ele, {
        trendId: ele.trendParentId ? ele.trendParentId : ele.trendId,
      })
    );
  }
};

// Getting industry from tagging information
export function filterIndustryFromTrends(trends) {
  if (!trends?.length) return [];
  // Filter trends and map to trendId
  const uniqueTrends = new Set(trends.filter((trend) => trend.trendParentId === 0 && trend.trendRoot === 0));
  return Array.from(uniqueTrends);
}

// Getting industryIds from industry information
export function filterIndustryIds(industries) {
  if (!industries?.length) return [];
  // Filter industries and map to trendId
  const uniqueIndustryIds = new Set(industries.filter((trend) => trend.trendParentId === 0 && trend.trendRoot === 0).map((trend) => trend.trendId));
  return Array.from(uniqueIndustryIds);
}

export const combineIndustriesWithWidgets = (industries, widgets, configValue, contentId) => {
  if (!industries?.length || !widgets?.length || !configValue?.length) return [];

  // Convert industries array to a map for faster lookup
  const trendMap = new Map(industries.map((trend) => [trend.trendId, trend]));

  // Convert configValue array to a map for faster lookup
  const configMap = new Map(configValue.map((config) => [config.name, config.contentMaxLimit]));

  // Combine widgets with their corresponding trend information
  const combinedData = widgets.reduce((acc, widget) => {
    const contentMaxLimit = configMap.get(widget.widgetConfigName); // Get contentMaxLimit from configValue
    const widgetContent = widget?.widgetContent || [];

    const hasValidContent = widgetContent?.some((content) => content?.widgetContentId === contentId);

    // Check contentMaxLimit condition
    if (contentMaxLimit !== undefined && widgetContent?.length >= contentMaxLimit && !hasValidContent) {
      return acc; // Skip this widget if widgetContent length exceeds contentMaxLimit
    }

    const trend = trendMap.get(widget.widgetIndustryId);

    if (trend) {
      const group = trend.trendName;
      const item = {
        id: widget.id,
        label: widget.widgetDisplayName,
      };

      const existingGroup = acc.find((g) => g.group === group);

      if (existingGroup) {
        existingGroup.items.push(item);
      } else {
        acc.push({ group, items: [item] });
      }
    }

    return acc;
  }, []);

  // Sort combined data by group name
  combinedData.sort((a, b) => a.group.localeCompare(b.group));

  return combinedData;
};

// Function to build a parent-child hierarchy
export const buildHierarchyContentType = (data) => {
  if (!data?.length) return [];
  const result = [];
  const map = {};
  data?.forEach((item) => {
    if (item.taxonomyLevel === 2) {
      map[item.id] = {
        id: item.id,
        contentType: item.taxonomyName,
        subContentType: [],
      };
    } else if (item.taxonomyLevel === 3) {
      const parent = map[item.taxonomyParentId];
      if (parent) {
        parent.subContentType.push({
          id: item.id,
          contentType: item.taxonomyName,
        });
      }
    }
  });
  // * Convert the map into an array
  Object.values(map).forEach((item) => {
    result.push(item);
  });

  return result;
};

export function transformContentTypeSubContentTypeData(data) {
  let result = [];
  if (!data?.length) return [];
  data?.forEach((category) => {
    category?.subContentType?.forEach((subType) => {
      result.push({
        label: subType.contentType,
        category: category.label,
        value: subType.contentType,
      });
    });
  });
  result?.sort((a, b) => a?.label?.localeCompare(b?.label));
  return result?.sort((a, b) => a?.category?.localeCompare(b?.category));
}

export function filterContentTypesAndSubContentTypes(contentTypes, selectedContentTypes, selectedSubContentTypes) {
  const filteredContentTypes = [];
  const filteredSubContentTypes = [];
  if (contentTypes?.length > 0 && selectedContentTypes?.length > 0 && selectedSubContentTypes?.length > 0) {
    selectedContentTypes?.forEach((contentType) => {
      const matchedContent = contentTypes?.find((content) => content.label === contentType);

      if (!matchedContent) return;

      if (!matchedContent.subContentType) {
        filteredContentTypes.push(contentType);
        return;
      }

      const selectedSubTypes = matchedContent.subContentType
        ?.map((sub) => sub.contentType)
        ?.filter((subType) => selectedSubContentTypes?.includes(subType));

      if (selectedSubTypes.length === matchedContent.subContentType.length) {
        filteredContentTypes.push(contentType);
      } else if (selectedSubTypes.length > 0) {
        filteredSubContentTypes.push(...selectedSubTypes);
      }
    });
  }

  return {
    contentTypesFilter: [...new Set(filteredContentTypes)],
    subContentTypesFilter: [...new Set(filteredSubContentTypes)],
  };
}

export const formattedDate = (date) => {
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).replace(/ /g, '-');
}

export const stripHtml = (input) => {
  if (typeof input !== "string") return "";
  const doc = new DOMParser().parseFromString(input, "text/html");
  const text = doc.body.textContent || "";
  return text.replace(/\u00a0/g, " ").trim();
};